const slidewords ={
    'sldc':{
        'es':{c1:'Diseñador UX/UI',c2:'Diseñador Gráfico'},
        'en':{c1:'UX/UI Designer',c2:'Graphic Designer'}},
    'sldd':{
        'es':'Diseñador UX/UI con foco en el usuario, siempre buscando generar valor de cara a las personas y eficiencia para el negocio.',
        'en':'UX/UI Designer with a user-focused approach, always seeking to generate value for people and efficiency for the business.'},
    'slds':{
        'es':['Orientado a objetivos','Trabajo en equipo','User centered','Design thinking','Scrum','Agile','Diseño digital'],
        'en':['Goal-oriented','Teamwork','User-centered','Design Thinking','Scrum','Agile','Digital Design']},
    'sllk':{
        'es':'Perfil en Linkedin',
        'en':'My profile on linkedin'},
    'sBllt':{
        'es':'Sobre mí',
        'en':'About me'},
    'sBldd':{
        'es':'Amigable y de buen trato, siempre abierto a escuchar y discutir, en buena, diferentes puntos de vista. Dentro de mis intereses y hobbies están la fotografía, la ilustración, el deporte y las motos. Me encanta salir a dar vueltas en moto, cambiar los paisajes por un rato y comer lo que toque en el viaje.',
        'en':'Friendly and approachable, always open to listening and discussing, in a good way, different points of view. Among my interests and hobbies are photography, illustration, sports, and motorcycles. I love going for rides on my motorcycle, changing the scenery for a while, and eating whatever comes my way during the trip.'},
    'sBlds':{
        'es':['Fotografía','Ilustración','<Código>','Deportes','Motos','Ciclismo','Diseño','Fútbol','Espacio','Astro fotografía'],
        'en':['Photography','Illustration','Code','Sports','Motorcycles','Cycling','Design','Soccer','Space','Astrophotography']},
    'sldcon':{
        'es':[['linkedin','Perfil de Linkedin'],['wsp','(+56) 9 4211 0098'],['mail','david.trollund@gmail.com'],['distance','La Florida, Santiago.']],
        'en':[['linkedin','Profile in Linkedin'],['wsp','(+56) 9 4211 0098'],['mail','david.trollund@gmail.com'],['distance','La Florida, Santiago, Chile.']]
}}

export default slidewords;